import { render, staticRenderFns } from "./FeeScheduleAndInterestRates.vue?vue&type=template&id=4ca37cc2&scoped=true"
import script from "./FeeScheduleAndInterestRates.vue?vue&type=script&lang=ts"
export * from "./FeeScheduleAndInterestRates.vue?vue&type=script&lang=ts"
import style0 from "./FeeScheduleAndInterestRates.vue?vue&type=style&index=0&id=4ca37cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca37cc2",
  null
  
)

export default component.exports